define([
    'lodash',
    'santa-components',
    'coreUtils',
    'skins',
    'itunesButton/skins/skins.json',
    'componentsCore'
], function (_, santaComponents, coreUtils, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const languagePlaceHolder = '{{langCode}}';
    const imagePath = `itunesButton/iTunesBtn_${languagePlaceHolder}.svg`;
    const ITUNES_LABEL = 'Get it on iTunes';

    const SUPPORTED_LANGS = ['da', 'de', 'en', 'es', 'fr', 'it', 'jp', 'ko', 'nl', 'no', 'pl', 'pt', 'ru', 'sv', 'tr'];
    //"hi" (hindi) language is supported by the editor but itunes doesn't have a version for it (12/2016)

    function createDownloadButtonObject(compProps, compData, getTranslatedAriaLabel) {
        const downloadButton = {
            parentConst: santaComponents.utils.createReactElement.bind(null, 'a'),
            target: compProps.openIn
        };
        if (compData.downloadUrl) {
            downloadButton.href = compData.downloadUrl;
        }
        downloadButton['aria-label'] = getTranslatedAriaLabel('AriaLabels', 'ItunesButton_AriaLabel_Button_GetOnItunes', ITUNES_LABEL);
        downloadButton.title = ITUNES_LABEL;
        return downloadButton;
    }

    function getLanguage(propLang, userLanguage) {
        if (propLang === 'userLang') {
            return userLanguage;
        }
        return propLang;
    }

    function getButtonImageSrc(langProp, userLanguage, serviceTopology) {
        const imageBaseUrl = getButtonImageBaseUrl(serviceTopology);
        langProp = getLanguage(langProp, userLanguage);
        if (!_.includes(SUPPORTED_LANGS, langProp)) {
            langProp = 'en';
        }
        return imageBaseUrl.replace(languagePlaceHolder, langProp.toUpperCase()); //Server saves data in lowercase, image file name is in uppercase
    }

    function getButtonImageBaseUrl(serviceTopology) {
        return coreUtils.media.getMediaUrl(serviceTopology, imagePath);
    }

    /**
     * @class components.itunesButton
     * @extends {core.skinBasedComp}
     */
    const itunesButton = {
        displayName: 'ItunesButton',

        mixins: [componentsCore.mixins.skinBasedComp],

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            structure: santaComponents.santaTypesDefinitions.Component.structure,
            serviceTopology: santaComponents.santaTypesDefinitions.ServiceTopology.serviceTopology,
            userLanguage: santaComponents.santaTypesDefinitions.WixUserSantaTypes.userLanguage.isRequired,
            getTranslatedAriaLabel: santaComponents.santaTypesDefinitions.Accessibility.getTranslatedAriaLabel.isRequired
        },

        static: {
            useSantaTypes: true
        },

        getSkinProperties() {
            return {
                downloadButton: createDownloadButtonObject(this.props.compProp, this.props.compData, this.props.getTranslatedAriaLabel),
                '': {
                    style: {
                        height: `${this.props.structure.layout.width * 40 / 110}px`
                    }
                },
                itunesImg: {
                    src: getButtonImageSrc(this.props.compProp.language, this.props.userLanguage, this.props.serviceTopology)
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.ItunesButton', itunesButton);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return itunesButton;
});
